import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyMultiple20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTypographyMultiple20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 4.012h12.504V6.25a.75.75 0 0 1-1.5 0v-.738H8V14.5h1.25a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1 0-1.5H6.5V5.512h-4v.738a.75.75 0 0 1-1.5 0zM13.5 10H10V8.5h8.5V10H15v6h-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyMultiple20);
